export default "__VITE_ASSET__Dw2ZoPuK__"